 
import { useIdleTimer } from "react-idle-timer";
import { useAuth } from "./useAuth";
import { useState, useEffect } from "react";

export const useIdleLogout = () => {
  const { logout, userdisplay } = useAuth();

  const [showSessionDialog, setShowSessionDialog] = useState(false);

  const idleTimer = useIdleTimer({
    timeout: 10 * 60 * 1000, // دقيقة

    promptBeforeIdle: 9 * 60 * 1000, // قبل 30 ثانية

    disabled: !userdisplay,

    onPrompt: () => {
      if (!userdisplay) return;

      setShowSessionDialog(true);
    },

    onIdle: () => {
      if (!userdisplay) return;

      setShowSessionDialog(false);

      console.log("AUTO LOGOUT");

      logout();
    },
  });

  // إعادة تشغيل العداد بعد تسجيل الدخول
  useEffect(() => {
    if (userdisplay) {
      idleTimer.reset();

      console.log("SESSION RESET");
    }
  }, [userdisplay]);

  const continueSession = () => {
    idleTimer.reset();

    setShowSessionDialog(false);

    console.log("SESSION CONTINUED");
  };

  return {
    showSessionDialog,
    continueSession,
    logout,
    setShowSessionDialog,
  };
};